// extracted by mini-css-extract-plugin
export const courseName = "tree-module--courseName--2K7IJ";
export const treeContentContainer = "tree-module--treeContentContainer--12Xe6";
export const TreeContainer = "tree-module--TreeContainer--1aGLs";
export const icon = "tree-module--icon--1pAKG";
export const number = "tree-module--number--28pJy";